/** 全社ロールの呼び名(SPEC §2.4)。 */
export const ROLE_LABELS: Record<string, string> = {
  SYSTEM_ADMIN: "全体の管理者",
  GENERAL: "一般",
};
